import { render, staticRenderFns } from "./EditPunishmentApproval.vue?vue&type=template&id=8cea26d4&scoped=true"
import script from "./EditPunishmentApproval.vue?vue&type=script&lang=js"
export * from "./EditPunishmentApproval.vue?vue&type=script&lang=js"
import style0 from "./EditPunishmentApproval.vue?vue&type=style&index=0&id=8cea26d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cea26d4",
  null
  
)

export default component.exports